export default {
  lang: 'English',
  homeScreen: {
    title: ' The Truth Is On The Water', // Product specific
    stayConnected: 'Stay Connected',
    comingSoon: 'Coming Soon',
  },
  loginScreen: {
    title: 'Professional Training and Sales Enablement Program', // Product specific (TravPRO text or ChannelPRO text)
    welcome: {
      headerTop: 'Welcome To The Future of Virtual Trade Shows!',
      headerBottom: '', // Product specific
    },
    sellingPoints: {
      // All selling points can be product specific
      0: 'Insightful, relevant content tracks and hosted roundtable discussions for a deeper PROspective',
      1: 'Chat directly with destinations, brands in booths, and peers in the networking lounge',
      2: 'New B2B2C Booth experience, share the booth with your clients as easy conversation starters',
      3: "Win Prizes by collecting XP’s – 'Experience Points' throughout all areas of the show",
      4: 'Enjoy this new mobile Xpo platform!',
    },
    emailPrompt: 'Please enter your email address to confirm that you are a travel professional.', // Product specific (TravPRO or ChannelPRO text)
    tAndC: {
      agree: 'By continuing you agree with our ',
      privacyPolicy: 'privacy policy',
      and: ' and ',
      termsConditions: 'terms and conditions',
    },
    fields: {
      select: 'Select an option below',
      agency: 'Dealer',
      email: 'Email *',
      firstName: 'First Name *',
      lastName: 'Last Name *',
      agencyName: 'Company Name',
      jobTitle: 'Title',
      manager: 'Are you an owner or a manager?',
      experience: 'Years of experience',
      streetAddress: 'Street Address',
      city: 'City',
      stateProvince: 'State / Province',
      zipCode: 'Zip Code *',
      country: 'Country',
      phone: 'Phone number',
      fax: 'Fax',
      agencyWebsite: 'Agency website',
      required: 'Required',
      invalidEmail: 'Invalid email address',
      opt: 'Opt in to marketing',
      password: 'Password *',
      passwordConfirm: 'Confirm Password *',
    },
    noAgent: {
      noAgentButton: "I'm not a dealer",
      title: 'Thank you for your interest in XpoPRO.', // Product specific
      messageWeb:
        'The content on this site is exclusively for XpoPRO professionals. \n To learn more about the XpoPRO, please visit: ', // Product specific
      messageMobile:
        "Some content on this app is exclusively for XpoPRO professionals, but feel free to browse a preview of what this app has to offer by pressing 'Continue'.", // Product specific
      continue: 'Continue',
      visitWebsite: 'Visit website',
    },
    newUser: 'New User',
    register: 'Register',
    registered: 'This email is already registered',
  },
  welcomeScreen: {
    title: 'Welcome to the\nXpoPRO Sales Companion', // Product specific
    helloUser: 'Hello {{name}}',
    hello: 'Hello,',
    fromAgency: 'from {{agency}}',
    notUser: 'Not {{name}}?',
    introOnline:
      "Train immediately online or preload the content so it's always available for offline use!",
    introOffline:
      'You already have the latest version preloaded. Start training or selling anytime, anywhere!',
    startTraining: 'Start training',
    continueTraining: 'Continue training',
    graduated: 'Congratulations, Graduate!',
    downloader: {
      preload: 'Preload',
      stop: 'stop',
      init: 'Initializing...',
      lastUpdate: 'Last update: ',
    },
  },
  trainingScreens: {
    start: 'Start',
    continue: 'Continue',
    restart: 'Restart',
    durationInMinutes: '{number} minutes',
    percentageComplete: '{number}% Complete',
    unlock: 'Unlock this chapter by completing training chapter {number}.',
    unlockSubtitle: 'Unlock more chapters by completing training chapters.',
    allUnlocked: 'You have unlocked all chapters!',
    certificate: 'Certificate',
    courseComplete: 'Continue',
    endReached: "You've reached the end",
    retainEnd:
      'Use the top bar to navigate around in this chapter or press the back button to return to the overview.',
    watchListenRead: 'Watch, Listen & Read more',
    trouble: "It looks like you're having trouble, would you like to skip this question?",
    confirm: 'Confirm your answer',
    choose: 'Please choose an answer',
    skip: 'Skip question',
    retry: 'Try Again',
    fillBlanks: 'Fill in the blank(s):',
  },
  nav: {
    home: 'Home',
    train: 'Train',
    retain: 'Retain',
    directory: 'Directory',
    promote: 'Engage',
    sell: 'Toolbox',
    info: 'Info',
    media: 'Media',
    favorites: 'Favorites',
    contact: 'Contact',
    reportCard: 'View Diploma',
    accountSettings: 'Account Settings',
    messages: 'Messages',
    search: 'Search',
    directory: 'Product Directory',
  },
  contentHeaders: {
    train: 'Training Library',
    retain: 'Retain',
    subapps: 'Partner Specialist Programs',
  },
  pageDescriptions: {
    train: 'Sell XpoPRO with Confidence through this comprehensive program.',
    retain: 'Explore all content to reinforce your knowledge',
    promote: 'Media Assets Organized for Easy Access and Sharing',
    sell: 'Easy Access To Sales Collateral.',
    favorites: 'Check out your personally favorited content',
    search: 'Look through all content',
    subapps: 'Learn more from our partners',
  },
  general: {
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    back: 'Back',
    close: 'close',
    page: 'Page',
    search: 'Search',
    logIn: 'Log in',
    logOut: 'Log Out',
    viewItem: 'View {type}',
    imageNotFound: 'Image not found',
    noResultsFor: 'No results have been found for: {{query}}',
    noFavorites: "You don't have any favorites yet.",
    noMessages: "You haven't received any messages yet!",
    resultsFor: 'Results for: {{query}}',
    showAll: 'Show all',
    connectionError: 'Connection error',
    alreadyExists: 'Already exists',
    pageNotFound: '404 Page Not Found!',
    oops: 'Uh oh...',
    overview: 'Return to overview',
    complete: 'Continue',
    courseComplete: 'Course Complete!',
    chapterComplete: 'Chapter Completed!',
    message: '{count} Message',
    messagePlural: '{count} Messages',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  errors: {
    comingSoon: 'Coming Soon!',
    missingContent: '',
  },
  questions: {
    dials: 'Rotate the dials to match the answer',
    fitb: 'Fill in the blank(s)',
    flip: 'Change the number to match the answer',
    multipleChoice: 'Pick the right answer(s)',
    slider: 'Pick the right answer using the slider',
    map: 'Answer the question by tapping the right location on the map',
    dropdown: 'Choose...',
    true: 'True',
    false: 'False',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  cookies: {
    consent: 'AGREE',
    optout: 'Opt-out',
    settings: 'Privacy Settings',
    message:
      "You haven't told us anything about your data privacy preferences! That's ok, but we'd like to offer you the best experience using the Sales Companion.",
    disabled: 'It looks like you have disabled the use of cookies.',
    use: 'The {{appName}} requires the use of cookies to deliver you the best experience.',
    details: 'What are the cookies used for?',
    enable: 'See how to enable your cookies {{here}}.',
    here: 'here',
  },
  notLoggedIn: {
    super: "You're not logged in",
    title: 'You need to be logged in to view this content',
    guest: 'Guest',
  },
  demo: {
    message:
      'This website is a demo of the final product. It is currently in-development and not a complete product.',
    consent: 'Understood!',
  },
  share: {
    header: 'Share this resource on your favorite social media!',
    download: 'download',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header: "It looks like you're trying to access the {appName} app from a mobile device",
    body: 'To download this program simply visit your app store and search for {appName} or click one of the buttons below',
    benefits: {
      header: 'This will provide you with:',
      1: 'Certificate of completion',
      2: 'Free, high-quality marketing materials',
      3: 'Qualify to participate in destination FAMS',
      4: 'High Impact Sales Information & Resources',
      5: 'Access to mobile Sales Companion App',
      6: 'Sales tips',
    },
  },
  homeView: {
    title: 'Liked our show? Sign up now for our other shows.',
    buttons: {
      signUp: 'Sign up',
    },
  },
  attendeeView: {
    toastMessage: {
      succesfullRegister: 'Successfully registered for',
      allreadyRegisted: "You're already registered for this show.",
    },
  },
};
